import { Box, HStack, Icon, Text, Tooltip } from '@chakra-ui/react';
import { Trans } from '@lingui/react/macro';
import { Info, SquareArrowOutUpRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { iconSize, pxToRem } from '@duke-hq/ui/constants/scalable';

export default function SidePanelContentHeader({
  title,
  tooltipText,
  to,
}: {
  title: string;
  tooltipText?: string;
  to?: string;
}) {
  return (
    <HStack w="full" gap="1" mb={3} justifyContent="space-between">
      <HStack>
        <Text fontSize="sm" fontWeight="bold" color="fg.muted">
          {title}
        </Text>
        {typeof tooltipText === 'string' && tooltipText.length > 0 ? (
          <Tooltip
            label={tooltipText}
            fontSize="xs"
            fontWeight="medium"
            shadow="none"
            hasArrow
            bg="bg.subtle"
            borderRadius="sm"
            border="1px"
            borderColor="border.emphasis"
            color="fg.default"
            width={pxToRem(224)}
            placement="top"
            px="2"
            py="0.5"
            sx={{
              '& .chakra-tooltip__arrow': {
                marginTop: '2px',
                borderBottom: '1px ',
                borderRight: '1px ',
                borderColor: 'border.emphasis',
              },
            }}
          >
            <Box display="inline-flex" alignItems="center" height="1rem">
              <Icon as={Info} color="fg.muted" boxSize={iconSize.xs} />
            </Box>
          </Tooltip>
        ) : null}
      </HStack>

      {to !== undefined ? (
        <Link to={to}>
          <HStack spacing="1" color="fg.subtle" fontSize="xs">
            <Trans>View list</Trans> <SquareArrowOutUpRight size={iconSize.xs} />
          </HStack>
        </Link>
      ) : null}
    </HStack>
  );
}
